<template>
	<div>
		<div class="MarkerPopup-contents">
			<h3>
				<a target="_blank" :href="`https://regio.gripp.com/d/company/edit/${data.id}`">
					{{ fullname }}
				</a>
			</h3>
			<div class="MarkerPopup-address" v-if="data.visitingaddress_street">
				<div>{{ data.visitingaddress_street }} {{ data.visitingaddress_streetnumber }}</div>
				<div v-if="data.visitingaddress_zipcode">{{ data.visitingaddress_zipcode }}</div>
				<div v-if="data.visitingaddress_city">{{ data.visitingaddress_city }}</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="additional != null && additional.customfield_afspraakdatum != null">
				<div class="appointment-item">
					<span>Afspraak:</span>
					<span>{{ parseDate(additional.customfield_afspraakdatum) }}</span>
				</div>
				<div class="appointment-item">
					<span>Tijd:</span>
					<span>{{ calculatePlanningAppointmentEndTime(additional.customfield_afspraaktijdstip, additional.customfield_afspraakwoningtype ===
					'vrijstaande-woning' ? '1.25' : '1') }}</span>
				</div>
				<div class="appointment-item" v-if="additional.agent != null && additional.agent.display_name">
					<span>Accountmanager:</span>
					<span>{{ additional.agent.display_name }}</span>
				</div>
			</div>
		</div>
		<a class="MarkerPopup-phone" :href="'tel:' + phoneNumber" v-if="phoneNumber">
			<PhoneIcon/>
			{{ phoneNumber }}
		</a>
		<div class="MarkerPopup-lastupdated" v-if="additional != null && !empty(additional.customfield_laatstgebeldmarketing)">
			{{ additional.customfield_laatstgebeldmarketing }}
		</div>
		<div class="MarkerPopup-lastTimeline" v-if="data.lastTimeline != null && data.lastTimeline.message">
			{{ data.lastTimeline.message }}
		</div>
		<div class="MarkerPopup-tags" v-if="data.tags.length > 0">
			<span v-for="tag in data.tags" :key="tag.name" class="MarkerPopup-tag">{{ tag.name }}</span>
		</div>
		<div class="MarkerPopup-actions" v-if="filter.startsWith('quality/to_plan')">
			<Button @click="onClickQuality();">
				Kwaliteit
			</Button>
		</div>
		<div class="MarkerPopup-actions" v-if="filter.startsWith('quality/appointments')">
			<Button @click="onClickQuality();">
				Verplaatsen
			</Button>
			<DropdownButton>
				<template v-slot:button>Afzeggen</template>
				<Button @click="onClickDeleteAppointment($event, data.id, false);">Annuleren</Button>
				<Button @click="onClickDeleteAppointment($event, data.id, true);">Opnieuw Inplannen</Button>
			</DropdownButton>
			<DropdownButton class="agents-dropdown">
				<template v-slot:button>Med. wijzigen</template>
				<Button v-for="agent in agents"
						:key="agent.employee.id"
						@click="onClickReassignAppointment($event, data.id, agent.employee.id);">
					{{ agent.display_name }}
				</Button>
			</DropdownButton>
			<Button
				@click="onClickCreateNote('Kwaliteit');">
				Notitie
			</Button>
		</div>
		<div class="MarkerPopup-actions" v-if="filter.startsWith('quality/historic')">
			<DropdownButton v-if="additional != null && additional.projects.length > 1">
				<template v-slot:button>Support</template>
				<Button v-for="project in additional.projects" @click="onClickSupport(project.id)" :key="'project' + project.id">{{ project.name }}</Button>
			</DropdownButton>
			<a class="Button" :href="'/kwaliteit-afspraken/' + data.id" target="_blank">KWALITEIT</a>
		</div>
	</div>
</template>

<script>
import CreateSupportTicketModal from "@/components/CreateSupportTicketModal.vue";
import CreateQualityAppointment from "@/components/mapModal/CreateQualityAppointment.vue";
import {mapState, mapActions, mapGetters} from "vuex";
import Button from '@/components/Button';
import DropdownButton from '@/components/DropdownButton';
import CreateAppointment from '@/components/mapModal/CreateAppointment';
import CreateNote from '@/components/CreateNote';
import Collapsible from '@/components/Collapsible';
import { PhoneIcon } from 'vue-feather-icons';
import { calculatePlanningAppointmentEndTime, parseDate } from "@/utils";

export default {
	components: {
		Button,
		DropdownButton,
		CreateAppointment,
		PhoneIcon,
		Collapsible,
	},

	props: {
		data: Object,
		filter: String
	},

	data() {
		return {
			additional: null,
		};
	},

	beforeMount() {
		this.fetchAdditionalMarkerInfo({id: this.data.id}).then(data => {
			this.additional = data;
		});

		this.fetchAgents();
	},

	computed: {
		...mapState('map', {
			mapType: 'mapType',
		}),
		...mapState('data', {
			agents: 'agents',
		}),
		...mapGetters({
			allowedTo: "auth/allowedTo"
		}),
		phoneNumber() {
			if (!this.empty(this.data.phone)) {
				return this.data.phone;
			} else if (!this.empty(this.data.mobile)) {
				return this.data.mobile
			} else {
				return null;
			}
		},

		fullname() {
			const salutations = {
				1: 'Dhr.',
				2: 'Mevr.',
				3: 'Dhr/Mevr.',
			};

			let name = [];
			if (this.data.salutation !== '') name.push(salutations[parseInt(this.data.salutation)]);
			if (this.data.initials !== '') name.push(this.data.initials);
			if (this.data.infix !== '') name.push(this.data.infix);
			if (this.data.lastname !== '') name.push(this.data.lastname);
			if (name.length === 0) name.push(this.data.companyname);

			return name.join(' ');
		}
	},

	methods: {
		...mapActions({
			performAction: 'map/performAction',
			fetchAdditionalMarkerInfo: 'map/fetchAdditionalMarkerInfo',
			getProjectById: "projects/getProjectById",
			cancelAppointment: 'map/cancelAppointment',
			fetchAgents: 'data/fetchAgents',
			reassignAppointment: 'map/reassignAppointment'
		}),

		onClickCreateNote(type) {
			this.$modal.show(CreateNote, {data: this.data, type: type}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},

		onClickAction(button, type) {
			button.disable();

			this.performAction({
				company_id: this.data.id,
				user_id: this.$store.state.map.viewingUserId,
				type: type,
			}).then(result => {
				button.enable();
				this.$events.emit('map/closePopup');
			}).catch((error) => {
				console.log('error', error);
				console.log('error: possible error dupicated tag');
				this.$notify({
					group: 'app',
					title: 'Error',
					type: 'error',
					text: `Er is een fout opgetreden: ${error}`,
				});
				button.enable();
			});
		},

		onClickQuality() {
				this.$modal.show(CreateQualityAppointment, {
					company: this.data
				}, {
					classes: "modal",
					adaptive: true,
					scrollable: true,
					width: "100%",
					height: "auto",
					maxWidth: 600
				});
		},

		onClickSupport(projectId) {
			this.getProjectById({id: projectId}).then(project => {
				this.$modal.show(CreateSupportTicketModal, {
					project: project
				}, {
					classes: "modal",
					adaptive: true,
					scrollable: true,
					width: "100%",
					height: "auto",
					maxWidth: 1200
				});
			});
		},

		onClickDeleteAppointment(button, companyId, reschedule) {
			button.disable();

			this.cancelAppointment({company_id: companyId, reschedule: reschedule})
				.then(result => {
					button.enable();
					this.$notify({
						group: 'app',
						title: 'Afspraak verwijderen',
						type: 'success',
						text: `Afspraak verwijderd`,
					});
					this.$events.emit('map/closePopup');
					this.$emit('close');
				}).catch((error) => {
				button.enable();
				this.$notify({
					group: 'app',
					title: 'Afspraak verwijderen',
					type: 'error',
					text: error,
				});
			});
		},

		onClickReassignAppointment(button, companyId, agentId) {
			button.disable();

			this.reassignAppointment({company_id: companyId, agent_id: agentId})
				.then(result => {
					button.enable();
					this.$notify({
						group: 'app',
						title: 'Afspraak opnieuw toegewezen',
						type: 'success',
						text: `Afspraak opnieuw toegewezen`,
					});
					this.$events.emit('map/closePopup');
					this.$emit('close');
				}).catch((error) => {
				button.enable();
				this.$notify({
					group: 'app',
					title: 'Afspraak opnieuw toegewezen',
					type: 'error',
					text: error,
				});
			});
		},

		parseDate(date) {
			return parseDate(date);
		},

		calculatePlanningAppointmentEndTime(time, durationHours) {
			return calculatePlanningAppointmentEndTime(time, durationHours);
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		}
	}
};
</script>

<style scoped lang="scss">
.MarkerPopup-address, .MarkerPopup-appointment {
	border-bottom: 1px solid #eee;
	padding-bottom: 20px;
	margin-bottom: 0.5em;
}

.MarkerPopup-appointment:not(:first-child) {
	margin-top: 1em;
}

.appointment-item {
	display: flex;
	justify-content: space-between;
}

.appointment-action-container {
	display: flex;
	justify-content: flex-end;

	a {
		margin-top: 4px;
		background-color: #1aae9f;
		color: #fff;
		padding: 8px;
	}
}

.agents-dropdown ::v-deep .DropdownButton-options {
	max-height: 200px;
	overflow-y: auto;
}
</style>
